var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.522 37.191 27.046 7.368a3.48 3.48 0 0 0 -3.031 -1.72c-1.181 0 -2.359 0.573 -3.105 1.72L3.442 37.191c-1.269 2.286 0.405 5.16 3.101 5.16h34.95c2.685 0 4.365 -2.865 3.03 -5.16M7.35 38.421 23.942 9.972 40.68 38.419zm16.665 -7.776a2.575 2.575 0 1 0 0.002 5.152 2.575 2.575 0 0 0 0 -5.152m-1.965 -12.544v7.866a1.966 1.966 0 0 0 3.933 0v-7.866a1.966 1.966 0 0 0 -3.933 0",
    fill: "#8A0438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningModal);
export default __webpack_public_path__ + "static/media/WarningModal.393256f6b3019b7f976028448976163b.svg";
export { ForwardRef as ReactComponent };